module.exports = __webpack_public_path__ + "static/img/role-fr.d94be6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/role-fr.png
// module id = KxjA
// module chunks = 1